import { render } from "./CreateFolder.vue?vue&type=template&id=33177140&scoped=true&ts=true"
import script from "./CreateFolder.vue?vue&type=script&lang=ts"
export * from "./CreateFolder.vue?vue&type=script&lang=ts"

import "./CreateFolder.vue?vue&type=style&index=0&id=33177140&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33177140"]])

export default __exports__